import { render, staticRenderFns } from "./enterpriseAward.vue?vue&type=template&id=2bfb34a6&scoped=true"
import script from "./enterpriseAward.vue?vue&type=script&lang=js"
export * from "./enterpriseAward.vue?vue&type=script&lang=js"
import style0 from "./enterpriseAward.vue?vue&type=style&index=0&id=2bfb34a6&prod&scoped=true&lang=css"
import style1 from "./enterpriseAward.vue?vue&type=style&index=1&id=2bfb34a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfb34a6",
  null
  
)

export default component.exports